import { useQuery, UseQueryOptions } from "react-query";
import PreEngagementCheck from "../apiResources/PreEngagementCheck";

type PreEngagementCheckParams = {
  jobId: string | number;
  recruiterId: string | number;
};

const fetchPreEngagement = async (params: PreEngagementCheckParams) => {
  const check = new PreEngagementCheck(params);
  await check.save();

  return check;
};

export const useRecruiterPreEngagementCheck = (
  params: PreEngagementCheckParams,
  options?: UseQueryOptions<PreEngagementCheck>
) => {
  const query = async () => await fetchPreEngagement(params);

  return useQuery(["preEngagementCheck", params], query, options);
};
